import axios from "axios";

const apiClient = axios.create({
  baseURL: "/api/file",
});

const create = async (formData, onUploadProgress) => {
  return apiClient.post("/upload", formData, {
    headers: {
      "Content-Type": "multipart/mixed",
    },
    onUploadProgress,
  });
};

const remove = async (fileId) => {
  return apiClient.delete(`/${fileId}`);
};

export const fileUploadService = {
  create,
  remove,
};
